module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trust-form-layout"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticClass: "title-bar",
    attrs: {
      "span": 8
    }
  }, [_vm._t("title")], 2), _vm._v(" "), _c('el-col', {
    staticClass: "action-bar",
    attrs: {
      "span": 16
    }
  }, [_vm._t("action-bar")], 2)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "btn_tabs",
    attrs: {
      "span": 24
    }
  }, [_vm._t("btn_tabs")], 2)], 1), _vm._v(" "), _c('el-row', [_c('v-card', {
    staticClass: "main-content"
  }, [_vm._t("main-content")], 2)], 1), _vm._v(" "), _c('el-row', [_vm._t("sumbit_box")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f14e67e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Inventory/TrustFormLayout.vue
// module id = 772
// module chunks = 0